import React from "react";
import { ScanLine, AlertCircle, FileText, User } from "lucide-react";
import type { ActivityItem } from "../types/dashboard.js";

const ICON_MAP = {
  tap: ScanLine,
  incident: AlertCircle,
  report: FileText,
  user: User,
};
const COLOR_MAP = {
  tap: "text-success",
  incident: "text-danger",
  report: "text-accent",
  user: "text-text-secondary",
};

export default function ActivityFeed({
  items,
}: {
  items: ActivityItem[];
}): React.ReactElement {
  return (
    <ul className="divide-y divide-border">
      {items.map((it) => {
        const Icon = ICON_MAP[it.kind];
        const color = COLOR_MAP[it.kind];
        return (
          <li key={it.id} className="flex items-start gap-3 py-3 first:pt-0 last:pb-0">
            <span className={`flex h-7 w-7 items-center justify-center rounded-md bg-bg-raised border border-border flex-shrink-0 ${color}`}>
              <Icon className="h-3.5 w-3.5" />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm text-text-primary leading-snug">{it.message}</p>
              <div className="mt-0.5 flex items-center gap-2 text-2xs text-text-muted">
                <span>{it.ts}</span>
                {it.site && (
                  <>
                    <span>·</span>
                    <span className="truncate">{it.site}</span>
                  </>
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
